import NicoleAndChloe from '../../../assets/images/testimonials_static/nicole_chloe.jpg';
import AlexisAndChewy from '../../../assets/images/testimonials_static/alexis_chewy.jpg';
import HannahAndTanner from '../../../assets/images/testimonials_static/hannah_tanner.jpg';
import IsellaAndOreo from '../../../assets/images/testimonials_static/isella_oreo.jpg';
import KellyAndHiro from '../../../assets/images/testimonials_static/kelly_hiro.jpg';
import LisaAndSammy from '../../../assets/images/testimonials_static/lisa_sammy.jpg';
import SAndMaverick from '../../../assets/images/testimonials_static/s_maverick.jpg';
import SuzyAndMalibu from '../../../assets/images/testimonials_static/suzy_malibu.jpg';
import TheFrankFamily from '../../../assets/images/testimonials_static/the_frank_family.jpg';

export const reviewBlurbs: { name: string; description: string; image: string }[] = [
  {
    name: 'Nicole & Chloe',
    image: NicoleAndChloe,
    description:
      'Thank you Allie. For guiding us, supporting us, and for training me in how to train Chloe. I could not have done this without you.',
  },
  {
    name: 'Suzy & Malibu',
    image: SuzyAndMalibu,
    description:
      'There is comfort knowing that Allie is straight forward and wants the best for us and our pup. I tell my friends that I am going to training, not my puppy.',
  },
  {
    name: 'Lisa & Sammy',
    image: LisaAndSammy,
    description:
      'Sammi is a happy confident one year old Shepherd Heeler mix that will never have to be stuck in the yard or worse because of her aggression. Thank You Allie, for everything!',
  },
  {
    name: 'The Frank Family',
    image: TheFrankFamily,
    description:
      "I can't get over how easy it was to work with Allie... Our family is so grateful!!",
  },
  {
    name: 'Hannah & Tanner',
    image: HannahAndTanner,
    description:
      'Allie has improved my relationship with Tanner more than I thought was possible.. I can’t even begin to imagine what my life and Tanner’s life would be like right now if it weren’t for her guidance.',
  },
  {
    name: 'Kelly & Hiro',
    image: KellyAndHiro,
    description:
      'She saved our pack when we felt desperately lost, torn on the decision to surrender Hiro to a rescue. I am forever grateful to have crossed paths with her. THANK YOU ALLIE!!!!',
  },
  {
    name: 'Isella & Oreo',
    image: IsellaAndOreo,
    description:
      'One thing that stood out to me and speaks volumes is that from the first training session she has included the entire family.',
  },
  {
    name: 'S. & Maverick',
    image: SAndMaverick,
    description:
      'I went through 4 trainers in a year’s time. Then, I was referred to Allie. This is the best training available in my opinion, especially for a WORKING DOG. There needs to be mutual respect, not fear.',
  },
  {
    name: 'Alexis & Chewy',
    image: AlexisAndChewy,
    description:
      'Allie is a foundation style dog trainer, which means she focuses on the handler and canine’s relationship. I really appreciate this because she doesn’t try to change who Chewy is.',
  },
];
